export default __webpack_public_path__ + "static/media/spikes_6.32bd9cbe.svg";